import { useSearch } from "@tanstack/react-router";
import { useStore } from "@tanstack/react-store";
import { useCallback } from "react";

import { useGlobalSound } from "../lib/hooks/use-sound";
import { menuOpenStore, tooltipStore } from "../lib/store";
import { hideTooltip, showTooltip } from "../lib/tooltip";
import type { VoidComponent } from "../lib/types";
import { booleanAttribute } from "../lib/utils";
import { Button } from "./button";

const SoundToggleButton: VoidComponent = () => {
	const isMenuOpen = useStore(menuOpenStore);
	const search = useSearch({ from: "__root__" });
	const sound = useGlobalSound();
	const label = sound.muted ? "Unmute sound" : "Mute sound";

	const toggleSoundMute = useCallback(() => {
		if (sound.muted) {
			sound.unmute();
			tooltipStore.setState("Sound unmuted");
		} else {
			sound.mute();
			tooltipStore.setState("Sound muted");
		}
	}, [sound]);

	return (
		<div
			className="data-about:*:bg-white"
			data-about={booleanAttribute(search?.about === 1 || isMenuOpen)}
		>
			<Button
				icon={sound.muted ? "sound-off" : "sound-high"}
				aria-label={label}
				onClick={toggleSoundMute}
				onMouseEnter={showTooltip(label)}
				onMouseLeave={hideTooltip()}
				data-muted={booleanAttribute(sound.muted)}
			/>
		</div>
	);
};

export { SoundToggleButton };
